(function() {
  "use strict";

  angular.module("PrintixProviderGroup", [])

    .constant("RequiredGroupModelProperties", [
      "_links"
    ])

    .constant("PrintixGroupInfoConstants", {
      SHOW: "group_info_show",
      HIDE: "group_info_hide"
    })

    .constant('GROUP_EXTERNAL_FILTERS', [{
      name: "AzureADGroupTypes",
      parameter: "azureAD.groupTypeAlias",
      type: "radio",
      values: [{
          key: "azureAD.groupTypeAlias",
          value: "OFFICE_365",
          state: 'OFFICE_365',
        },
        {
          key: "azureAD.groupTypeAlias",
          value: "SECURITY",
          state: 'SECURITY',
        },
        {
          key: "azureAD.groupTypeAlias",
          value: "DISTRIBUTION",
          state: 'DISTRIBUTION',
        },
        {
          key: "azureAD.groupTypeAlias",
          value: "MAIL_ENABLED_SECURITY",
          state: 'MAIL_ENABLED_SECURITY',
        },
        {
          key: "azureAD.groupTypeAlias",
          value: 'ClearFilter',
          state: null
        }
      ]
    },
    // MUST use POST request
    // queueFilterMode: PRESENT_ON_ANY_EXCEPT || NOT_PRESENT
    // inUse: true
    {
      name: 'ShowAllGroups',
      parameter: 'provider',
      type: 'checkbox',
      values: [{
        key: 'provider',
        value: 'AzureAD',
        state: 'AZURE_AD'
      },
      {
        key: 'provider',
        value: 'Google',
        state: 'GOOGLE_GSUITE'
      },
      {
        key: 'provider',
        value: 'ClearFilter',
        state: null
      }]
    }
  ])

    .constant("GROUP_FILTERS_SHOW_ALL",
    {
      name: 'Groups',
      parameter: 'inUse',
      type: 'radio',
      values: [
        {
          key: 'inUse',
          value: 'OnlyGroupsUsedWithinPrintix',
          state: true
        },
        {
          key: 'inUse',
          value: 'OnlyGroupsNotUsedWithinPrintix',
          state: false
        },
        {
          key: 'inUse',
          value: 'AllAvailableGroups',
          state: null
        },
      ]
    },
    )

    .constant("GROUP_FILTERS_DOMAINS",{
        name: 'Domains',
        parameter: 'directories',
        type: 'flat_list',
        setBreaker: true,
        values: []
      }
    )

    .factory("GroupFilterModel",["TenantListService", "GROUP_FILTERS_SHOW_ALL", "GROUP_FILTERS_DOMAINS",
      function(TenantListService, GROUP_FILTERS_SHOW_ALL, GROUP_FILTERS_DOMAINS) {
        return function (useCase) {
          var GroupFilterModel = {
            useCase: useCase,
            filters: []
          }

          GroupFilterModel.init = function (useCase) {
            // BUILD THIS WAY TO MAKE IT EASIER TO ADD MORE FILTERS AT A LATER TIME
            switch (useCase) {
              case 'GROUP_LIST_VIEW':
              case 'GROUPS':
              case 'GROUP_QUEUE_MANAGEMENT':
              case 'SITE_MANAGEMENT':
              case 'SECURE_GROUPS':
              case 'PRINT_RULES_GROUPS':
              case 'HOME_OFFICE_GROUPS':
              case 'PRINT_QUEUE_GROUPS':
              case 'WORKFLOW_GROUPS':
                const DOMAINS = findDirectory()
                if (DOMAINS.values.length) {
                  GroupFilterModel.filters.push(DOMAINS)
                }
                GroupFilterModel.filters.push(angular.copy(GROUP_FILTERS_SHOW_ALL))
                break;
              case 'PRINT_QUEUE_GROUPS_STATIC':
              case 'HOME_OFFICE_QUEUE_GROUPS_STATIC':
                const DOMAIN_FILTER = findDirectory()
                if (DOMAIN_FILTER.values.length) {
                  GroupFilterModel.filters.push(DOMAIN_FILTER)
                }
                break;
              default:
                throw 'GroupModel: groupDomainFilter: scenario not found';
            }
          }

          function findDirectory() {

            function filterDirectoriesWithGroups(directories, brand) {
              return Object.values(directories)
                .filter(function (directory) {
                  return directory.groups_enabled;
                })
                .map(function (directory) {
                  return {
                    id: directory._links.self.href,
                    key: directory._links.self.href,
                    name: directory.name,
                    value: directory.name,
                    brand: brand,
                  };
                });
            }

            var azure_DIRECTORIES = TenantListService.currentTenant.info._embedded.tenantIdentityProviders.providers.azure.directories;
            var google_DIRECTORIES = TenantListService.currentTenant.info._embedded.tenantIdentityProviders.providers.google.directories;

            var azure_DIRECTORIES_WITH_GROUPS = filterDirectoriesWithGroups(azure_DIRECTORIES, 'azure');
            var google_DIRECTORIES_WITH_GROUPS = filterDirectoriesWithGroups(google_DIRECTORIES, 'google');

            const DOMAINS = angular.copy(GROUP_FILTERS_DOMAINS);

            azure_DIRECTORIES_WITH_GROUPS.forEach(function (directory) {
              DOMAINS.values.push(directory);
            });

            google_DIRECTORIES_WITH_GROUPS.forEach(function (directory) {
              DOMAINS.values.push(directory);
            });

            return DOMAINS;
          }

          GroupFilterModel.init(useCase);
          delete GroupFilterModel.init;
          return GroupFilterModel;

        };
      }
    ])

    .factory("GroupModel", ["$rootScope", "Utils", "$filter", "RequiredGroupModelProperties", "$http", "$q",
      "PrintixGroupInfoConstants", "TenantListService",
      function(
        $rootScope, Utils, $filter, RequiredGroupModelProperties, $http, $q,
        PrintixGroupInfoConstants, TenantListService
        ) {
        return function(groupDataReceived) {
          var GroupModel = {
            encodedLink: encodePrintQueueLink(groupDataReceived)
          };
          var GroupModelPrivate = {};

          function encodePrintQueueLink (groupDataReceived) {
            return encodeURIComponent(encodeURIComponent(groupDataReceived._links.self.href));
          }

          GroupModel.init = function(groupDataReceived) {
            if (Utils.objectPropertiesCheck(groupDataReceived, RequiredGroupModelProperties)) {
              GroupModel.info = angular.copy(groupDataReceived);
              GroupModel.options = {
                isSelected: false
              };
              GroupModel.customProperties = {};
              GroupModelPrivate.normalizeLinks();
              GroupModel.domainOrigin = findProvider(groupDataReceived);
            } else {
              throw "GroupModel: groupDataReceived is not valid";
            }
          };

          function findProvider (group) {
            var providerType = null;
            switch (group.provider) {
              case 'AZURE_AD':
                providerType = 'azure'
                break
              case 'GOOGLE_GSUITE':
                providerType = 'google'
                break
              default:
                providerType = group.provider.toLowerCase();
            }

            function findDirectory (group, providerType) {
              const directories = TenantListService.currentTenant.info._embedded.tenantIdentityProviders.providers[providerType].directories;

              let directory = null;
              for (const key in directories) {
                if (directories.hasOwnProperty(key) && directories[key].idp_tenant_identifier === group.directoryId) {
                  directory = directories[key];
                  break;
                }
              }
              return directory;
            }
            return findDirectory(group, providerType)
          }

          GroupModelPrivate.normalizeLinks = function() {
            angular.forEach(GroupModel.info._links, function(link, index) {
              if (angular.isObject(link) && !angular.isArray(link)) {
                var linkClean = link.href.split("?")[0];
                GroupModel.info._links[index].href = linkClean;
              }
            });
            var selfHrefSplit = GroupModel.info._links.self.href.split("/");
            GroupModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
          };

          GroupModelPrivate.replaceInfo = function(embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
            if (!GroupModel.info._embedded) {
              GroupModel.info._embedded = {};
            }
            if (embeddedKey) {
              GroupModel.info._embedded[embeddedKey] = angular.copy(data);
            } else {
              var embedded = angular.copy(GroupModel.info._embedded);
              var links = angular.copy(GroupModel.info._links);
              GroupModel.info = angular.copy(data);
              if (!doNotReplaceEmbeddedAndLinks) {
                GroupModel.info._embedded = embedded;
                GroupModel.info._links = links;
              }
              GroupModelPrivate.normalizeLinks();
            }
          };

          GroupModel.showInfo = function() {
            $rootScope.$emit(PrintixGroupInfoConstants.SHOW, GroupModel);
          };

          GroupModel.saveChanges = function(groupChanged) {
            if (groupChanged) {
              var patchObjectArray = Utils.getObjectsDifferencesForPatching(GroupModel.info, groupChanged.info);
              if (patchObjectArray && patchObjectArray.length > 0) {
                var deferred = $q.defer();
                $http.patch(GroupModel.info._links.self.href, patchObjectArray).then(function(response) {
                  GroupModelPrivate.replaceInfo(response.data);
                  deferred.resolve(response);
                }).catch(function(error) {
                  deferred.reject(error);
                });
                return deferred.promise;
              } else {
                return $q.resolve();
              }
            } else {
              throw "GroupModel.saveChanges: groupChanged is missing";
            }
          };

          GroupModel.syncGroupMembers = function () {
            var deferred = $q.defer()
            $http.post(GroupModel.info._links['px:synchronizeMemberships'].href).then(function(response) {
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }

          GroupModel.addHomeOfficePrinting = function () {
          };

          GroupModel.init(groupDataReceived);
          delete GroupModel.init;
          return GroupModel;
        };
      }
    ])


    .factory('GroupExternalListPaging', ['DEFAULT_ITEMS_PER_PAGE',
      function(DEFAULT_ITEMS_PER_PAGE){
        return function () {
          var GroupExternalListPaging = {};
          GroupExternalListPaging.pagingCriteria = {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            direction: 'ASC',
            hardcodedTest: true,
            match: null,
            embed: null,
            sort: 'NAME',
            queueFilterMode: null,
            provider: null,
            queue: null,
            'azureAD.groupTypeAlias': null

          }

          GroupExternalListPaging.getPagedUrlParameters = function() {
            var urlParameters =
              'page=' + GroupExternalListPaging.pagingCriteria.page +
              "&pageSize=" + GroupExternalListPaging.pagingCriteria.pageSize;

              if (GroupExternalListPaging.pagingCriteria.match) {
                urlParameters += '&match=' + GroupExternalListPaging.pagingCriteria.match;
              }

              if (GroupExternalListPaging.pagingCriteria['azureAD.groupTypeAlias']) {
                urlParameters += '&azureAD.groupTypeAlias=' + GroupExternalListPaging.pagingCriteria['azureAD.groupTypeAlias']
              }

              if (GroupExternalListPaging.pagingCriteria.provider) {
                urlParameters += '&provider=' + GroupExternalListPaging.pagingCriteria.provider
              }

              if (GroupExternalListPaging.pagingCriteria.queueFilterMode) {
                urlParameters += '&queueFilterMode=' + GroupExternalListPaging.pagingCriteria.queueFilterMode
              }

              if (GroupExternalListPaging.pagingCriteria.queue) {
                urlParameters += '&queue=' + GroupExternalListPaging.pagingCriteria.queue
              }

              if (GroupExternalListPaging.pagingCriteria.direction) {
                urlParameters += '&direction=' + GroupExternalListPaging.pagingCriteria.direction;
              }

              if (GroupExternalListPaging.pagingCriteria.sort) {
                urlParameters += '&sort=' + GroupExternalListPaging.pagingCriteria.sort;
              }

            return urlParameters;
          }

          return GroupExternalListPaging;
        }
      }
    ])

    .service('GroupExternalListService', ['$rootScope', '$q', '$http', 'TenantListService', 'GroupModel', 'Utils',
      function($rootScope, $q, $http, TenantListService, GroupModel, Utils){
        var printQueueListServiceAsObject = this;


        this.getGroupExernalListPagedPOST = function(groupListPaging) {
          var deferred = $q.defer()
          // groupListPaging.setInUseToCorrectValue();
          var postObject = groupListPaging.pagingCriteria;
          var params = '?page=' + groupListPaging.pagingCriteria.page + '&pageSize=20&direction=ASC&sort=NAME'
          var url = TenantListService.currentTenant.info._links['px:tenantGroups'].href + params;
          $http.post(url, postObject).then(function(response) {
            var groupListObject = {
              page: response.data.page,
              _links: response.data._links,
              list: []
            }
            if (response.data && response.data._embedded && response.data._embedded['px:groupResources']) {
              angular.forEach(response.data._embedded['px:groupResources'], function(groupData){
                groupListObject.list.add(new GroupModel(groupData));
              });
            }
            deferred.resolve(groupListObject);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }

        this.getGroupExernalListPaged = function(groupExternalListPaging) {
          if (groupExternalListPaging && TenantListService.currentTenant && TenantListService.currentTenant.info) {
            var deferred = $q.defer();
            var url = TenantListService.currentTenant.info._links['px:tenantGroups'].href + '?' + groupExternalListPaging.getPagedUrlParameters();
            $http.get(url).then(function(response){
              var groupExternalListObject = {
                page: response.data.page,
                _links: response.data._links,
                list: []
              }
              if (response.data && response.data._embedded && response.data._embedded['px:groupResources']) {
                angular.forEach(response.data._embedded['px:groupResources'], function(groupData) {
                  groupExternalListObject.list.add(new GroupModel(groupData));
                })
              }
              deferred.resolve(groupExternalListObject);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        }

        this.reloadGroupsFromProviders = function(groupExternalListPaging){
          var deferred = $q.defer();
          var urlPost = TenantListService.currentTenant.info._links['px:groupSynchronization'].href;
          $http.post(urlPost).then(function(response){
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }

      }
    ])

    .factory('GroupListPaging', ['DEFAULT_ITEMS_PER_PAGE',
      function(DEFAULT_ITEMS_PER_PAGE) {
        return function () {
          var GroupListPaging = {};
          GroupListPaging.pagingCriteria = {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            direction: 'ASC',
            match: null,
            sort: 'NAME',
            exclude: null,
            user: null,
            embed: null,
            queueFilterMode: null,
            userFilterMode: null,
            provider: null,
            inUse: null,
            queue: null
          }

          GroupListPaging.getPagedUrlParameters = function() {
            var urlParameters =
              'page=' + GroupListPaging.pagingCriteria.page +
              '&pageSize=' + GroupListPaging.pagingCriteria.pageSize;

            if (GroupListPaging.pagingCriteria.match) {
              urlParameters += '&match=' + GroupListPaging.pagingCriteria.match;
            }

            if (GroupListPaging.pagingCriteria.queueFilterMode) {
              urlParameters += '&queueFilterMode=' + GroupListPaging.pagingCriteria.queueFilterMode;
            }

            if (GroupListPaging.pagingCriteria.provider) {
              urlParameters += '&provider=' + GroupListPaging.pagingCriteria.provider
            }

            if (GroupListPaging.pagingCriteria.queue) {
              urlParameters += '&queue=' + GroupListPaging.pagingCriteria.queue;
            }

            if (GroupListPaging.pagingCriteria.direction) {
              urlParameters += '&direction=' + GroupListPaging.pagingCriteria.direction;
            }

            if (GroupListPaging.pagingCriteria.sort) {
              urlParameters += '&sort=' + GroupListPaging.pagingCriteria.sort;
            }

            if (GroupListPaging.pagingCriteria.exclude) {
              urlParameters += '&exclude=' + GroupListPaging.pagingCriteria.exclude;
            }

            if (GroupListPaging.pagingCriteria.user) {
              urlParameters += '&user=' + GroupListPaging.pagingCriteria.user;
            }

            if (GroupListPaging.pagingCriteria.inUse) {
              urlParameters += '&inUse=' + GroupListPaging.pagingCriteria.inUse;
            }

            if (GroupListPaging.pagingCriteria.userFilterMode) {
              urlParameters += '&userFilterMode=' + GroupListPaging.pagingCriteria.userFilterMode;
            }

            return urlParameters;
          }

          return GroupListPaging;
        }
      }
    ])

    .factory('GroupListPOSTPaging', ['DEFAULT_ITEMS_PER_PAGE', function(DEFAULT_ITEMS_PER_PAGE){
      return function () {
        var GroupListPOSTPaging = {};
        GroupListPOSTPaging.pagingCriteria = {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            direction: 'ASC',
            match: null,
            sort: 'NAME',
            exclude: null,
            user: null,
            embed: null,
            queueFilterMode: null,
            userFilterMode: null,
            directories: null,
            provider: null,
            inUse: null,
            queue: null
        }

        GroupListPOSTPaging.setInUseToCorrectValue = () => {
          var x = angular.copy(GroupListPOSTPaging.pagingCriteria)

          if (typeof GroupListPOSTPaging.pagingCriteria.inUse === "boolean") {
            return GroupListPOSTPaging;
          } else {

            if (GroupListPOSTPaging.pagingCriteria.inUse !== null) {
              GroupListPOSTPaging.pagingCriteria.inUse = false
            } else {
              GroupListPOSTPaging.pagingCriteria.inUse = true
            }
          }

        }

        return GroupListPOSTPaging;
      }
    }])

    .service("GroupListService", ["$rootScope", "GroupModel", "$filter", "Utils", "TenantListService", "$http", "$q",
      "USER_RIGHTS", "EventServiceEvents", "PrintQueue", "UserModel", 'WorkstationModel', 'GroupListPOSTPaging',
      function($rootScope, GroupModel, $filter, Utils, TenantListService, $http, $q,
        USER_RIGHTS, EventServiceEvents, PrintQueue, UserModel, WorkstationModel, GroupListPOSTPaging) {
        //START VARIABLES******************************************************************************************/
        var GroupListModelPrivate = {},
          groupListServiceAsObject = this;
        this.list = [];
        //END VARIABLES********************************************************************************************/


        //START GroupListService*********************************************************************************/
        GroupListModelPrivate.getGroup = function(url) {
          if (url) {
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
              var groupFound = groupListServiceAsObject.list.findElement({info: {_links: {self: {href: url}}}});
              if (!groupFound) {
                groupListServiceAsObject.list.add(new GroupModel(response.data));
              } else {
                groupListServiceAsObject.list[groupListServiceAsObject.list.indexOf(groupFound)] = new GroupModel(response.data);
              }
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "GroupListModelPrivate.getGroup: url is missing";
          }
        };

        this.getGroupByUrl = function (url) {
          if (url) {
            var deferred = $q.defer();
            $http.get(url).then(function(response) {
              deferred.resolve(new GroupModel(response.data));
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "GroupListModelPrivate.getGroup: url is missing";
          }
        }

        this.getGroupPrintQueues = function (url, requestObject) {
          if (url) {
            var deferred = $q.defer();
            $http.post(url, requestObject).then(function(response) {
              var printQueueListObject = {
                list: [],
                page: null
              }
              printQueueListObject.page = response.data.page;
              if (response.data._embedded) {
                angular.forEach(response.data._embedded['px:printerQueueResources'], function(printQueue) {
                  printQueueListObject.list.push(new PrintQueue(printQueue));
                })
              }
              deferred.resolve(printQueueListObject);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "GroupListModelPrivate.getGroup: url is missing";
          }
        }

        this.getGroupUsers = function (url, userPaging) {
          var deferred = $q.defer();
          $http.get(url + userPaging.getPagedUrlParameters()).then(function(response) {
            var userObject = {
              page: response.data.page,
              list: []
            }
            if (response.data._embedded) {
              angular.forEach(response.data._embedded['px:tenantUserResources'], function(user) {
                userObject.list.push(new UserModel(user));
              })
            }
            deferred.resolve(userObject);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }

        this.getGroupComputers = function (url, workstationPaging) {
          var deferred = $q.defer()
          $http.get(url + "?embed=adapters,queues,tasks,networks" + '&' + workstationPaging.getPagedUrlParameters()).then(function(response) {
            var workStationsListObject = {
              page: response.data.page,
              _links: response.data._links,
              list: []
            };
            if (response.data && response.data._embedded && response.data._embedded["px:workstationResources"]) {
              angular.forEach(response.data._embedded["px:workstationResources"], function(workstationsData) {
                workStationsListObject.list.add(new WorkstationModel(workstationsData));
              });
            }
            deferred.resolve(workStationsListObject);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }

        this.deleteGroup = function(group, isEvent) {
          if (group) {
            if (isEvent) {
              groupListServiceAsObject.list.remove(group);
            } else {
              var deferred = $q.defer();
              $http.delete(group.info._links.self.href).then(function(response) {
                groupListServiceAsObject.list.remove(group);
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            }
          } else {
            throw "GroupListModelPrivate.deleteGroup: group is missing";
          }
        };

        this.addNewGroup = function(groupName) {
          if (groupName) {
            var deferred = $q.defer();
            $http.post(TenantListService.currentTenant.info._links["px:tenantGroups"].href, {
              name: groupName
            }).then(function(response) {
              if (!groupListServiceAsObject.list.contains({
                  info: {
                    _links: {
                      self: {
                        href: response.data._links.self.href
                      }
                    }
                  }
                })) {
                groupListServiceAsObject.list.add(new GroupModel(response.data));
              }
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "GroupListService.addNewGroup: groupName is missing";
          }
        };

        this.addExternalGroupsBulkToTenant = function (groups) {
          if (groups) {
            var deferred = $q.defer();
            var dataToSend = [];
            for (var i = 0; i < groups.length; i++) {
              var group = {
                provider: groups[i].info.provider,
                externalId: groups[i].info.externalId,
                initialSync: groups[i].info.registeredForSync
              }
              dataToSend.push(group);
            }
            var url = groups[0].info._links['px:createGroup'].href;
            $http.post(url, dataToSend).then(function(response){
              deferred.resolve(response);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.addExternalGroupsBulk is missing a group';
          }
        }

        this.addSecuritySettingOnGroups = function(url, groups) {
          var deferred = $q.defer();
          $http.post(url, groups).then(function(response) {
            deferred.resolve(response);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }

        GroupListModelPrivate.readGroupListRequest = function(response) {
          if (response.data) {
            if (response.data._embedded && response.data._embedded["px:groupResources"]) {
              angular.forEach(response.data._embedded["px:groupResources"], function(groupData) {
                groupListServiceAsObject.list.add(new GroupModel(groupData));
              });
            }
          } else {
            throw "GroupListModelPrivate.readGroupListRequest: groupListDataReceived or groupListDataReceived._embedded.groups are missing";
          }
        };

        this.getGroupListPaged = function(groupListPaging) {
          if (groupListPaging && TenantListService.currentTenant && TenantListService.currentTenant.info) {
            var deferred = $q.defer();
            var url = TenantListService.currentTenant.info._links['px:tenantGroups'].href + '?' + groupListPaging.getPagedUrlParameters();
            $http.get(url).then(function(response){
              var groupListObject = {
                page: response.data.page,
                _links: response.data._links,
                list: []
              }
              if (response.data && response.data._embedded && response.data._embedded['px:groupResources']) {
                angular.forEach(response.data._embedded['px:groupResources'], function(groupData){
                  groupListObject.list.add(new GroupModel(groupData));
                });
              }
              deferred.resolve(groupListObject);
            }).catch(function(error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        }

        this.getGroupListPagedByPost = function(groupListPaging) {
          var deferred = $q.defer()
          // groupListPaging.setInUseToCorrectValue();
          var postObject = groupListPaging.pagingCriteria;
          var params = '?page=' + groupListPaging.pagingCriteria.page + '&pageSize=20&direction=ASC&sort=NAME'
          var url = TenantListService.currentTenant.info._links['px:tenantGroups'].href + params;
          $http.post(url, postObject).then(function(response) {
            var groupListObject = {
              page: response.data.page,
              _links: response.data._links,
              list: []
            }
            if (response.data && response.data._embedded && response.data._embedded['px:groupResources']) {
              angular.forEach(response.data._embedded['px:groupResources'], function(groupData){
                groupListObject.list.add(new GroupModel(groupData));
              });
            }
            deferred.resolve(groupListObject);
          }).catch(function(error) {
            deferred.reject(error);
          });
          return deferred.promise;
        }

        this.getGroupList = function() {
          if ($rootScope.currentUser) {
            if (TenantListService.currentTenant && TenantListService.currentTenant.info._links["px:tenantGroups"].href) {
              groupListServiceAsObject.list = [];
              var deferred = $q.defer();
              $http.get(TenantListService.currentTenant.info._links["px:tenantGroups"].href).then(function(response) {
                GroupListModelPrivate.readGroupListRequest(response);
                deferred.resolve(response);
              }).catch(function(error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              throw "GroupListService.getGroupList: TenantListService.currentTenant or TenantListService.currentTenant.info._links[px:tenantGroups].href are missing";
            }
          }
        };

        if (!$rootScope.currentUser) {
          var listener = $rootScope.$watch(function() {
            return $rootScope.currentUser;
          }, function() {
            if ($rootScope.currentUser) {
              // groupListServiceAsObject.getGroupList();
              listener();
            }
          }, false);
        } else {
          // groupListServiceAsObject.getGroupList();
        }
        //END GroupListService***********************************************************************************/


        //START EVENT LISTENERS*************************************************************************************/
        var watch = $rootScope.$watch(function() {
          return $rootScope.currentUser;
        }, function() {
          if ($rootScope.currentUser && $rootScope.currentUser.info &&
            $filter("contains")($rootScope.currentUser.info._embedded.permissions.permissions, USER_RIGHTS.ADMIN_LOGIN)) {

            watch();

            $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.GROUP_ADDED, function(name, data) {
              GroupListModelPrivate.getGroup(data.group);
            });

            $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.GROUP_REMOVED, function(name, data) {
              var groupFound = groupListServiceAsObject.list.findElement({
                info: {
                  _links: {
                    self: {
                      href: data.group
                    }
                  }
                }
              });
              if (groupFound) {
                groupListServiceAsObject.deleteGroup(groupFound, true);
              }
            });
          }
        });
        //END EVENT LISTENERS***************************************************************************************/
      }
    ]);
})();
